import { Kb3dModel } from '../decorators/kb3d-decorator';
import { instanceOf } from '../decorators/model-utils';
import { ICylinderNode } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';
import { PrimitiveMeshNode } from './primitive-mesh-node';

@Kb3dModel({
    token: Token.ConeNode,
})
export class ConeNode extends PrimitiveMeshNode implements ICylinderNode {
    public constructor() {
        super();
    }
    public height: number;
    public radiusTop: number;
    public radiusBottom: number;
    public tessellation: number;
}

export function isConeMesh(node: Kb3dObject): node is ConeNode {
    return instanceOf(node, Token.ConeNode);
}
